








































import { Component, Watch, Vue, Prop, Emit } from 'vue-property-decorator'; // デコレータ
// 共通機能
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
// 定数ファイル
import { Constants } from '../../CommonUtils/fixed/Constants';
import { UketsukeConstants } from '../fixed/UketsukeConstants';
import { Message } from '../../CommonUtils/fixed/Message';
// 共通モジュール
import { supervisingModule } from '../../store/modules/OperationSupervising';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2023.07.04 [2023F-05] add
 */
@Component
export default class AccepterPasswordReconfigRequest extends ApiAccessBase {
  private isRegist: boolean = false;

  private created() {
    this.screenTitle = 'ユーザID確認/パスワード再設定要求';
    // 可変項目設定
    this.setVariablecolsState(['password_reconfig_info']);
    // APIアクセス
    this.apiAccess(UketsukeConstants.PASSWORD_RECONFIG_REQUEST_PATH + '/init/' + supervisingModule.GET_TENANT_ID, Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
        }
      },
    );
  }

  /**
   * 登録
   */
  private registData() {
    // 入力チェック
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // 登録処理
    if (window.confirm(Message.I0003)) {
      this.apiAccess(
        UketsukeConstants.PASSWORD_RECONFIG_REQUEST_PATH + '/create/' + supervisingModule.GET_TENANT_ID, Constants.API_METHOD_POST, true, false,
      ).then((result) => {
        this.hrefElement('accepterPasswordReconfigRequest', -50);
        if (result === Constants.API_RESULT_SUCCES) {
          this.isRegist = true;
        }
      });
    }
  }
  /**
   * 前画面に戻る
   */
  private returnPrevious() {
      // 前画面に戻る
      router.push('login');
  }
}

